"use client"

import clsx from "clsx"
import { NpIcon } from "./NpIcon"

export type NpRadioSelectButtonVariant = "radio" | "checkbox" | "add"

export type NpRadioSelectButtonProps = {
  variant: NpRadioSelectButtonVariant
  active?: boolean
  onClick?: () => void
}

export const NpRadioSelectButton = ({ variant, active, onClick }: NpRadioSelectButtonProps) => {
  const Element = variant === "add" ? "button" : "div"
  const type = variant === "add" ? "button" : undefined

  const greenBg = (variant === "checkbox" || variant === "add") && active

  return (
    <Element
      type={type}
      onClick={onClick}
      onKeyDown={undefined}
      className={clsx("group flex size-10 items-center justify-center overflow-hidden rounded-full", {
        "outline-none": variant !== "add",
      })}
    >
      <div
        className={clsx(
          "border-np-green flex size-8 items-center justify-center overflow-hidden rounded-full border transition-colors hover:transition-none",
          {
            "bg-white": !greenBg,
            "bg-np-green": greenBg,
            "group-hover:bg-np-green/10 group-active:bg-np-green/20": variant === "radio" || !active,
            "group-hover:bg-np-green/90 active:bg-np-green": variant !== "radio" && active,
          },
        )}
      >
        {variant === "radio" && (
          <div
            className={clsx("size-5 rounded-full transition-colors hover:transition-none", {
              "group-hover:bg-np-green25": !active,
              "bg-np-green": active,
            })}
          />
        )}

        {variant === "checkbox" && (
          <NpIcon
            name="check"
            className={clsx("transition-colors hover:transition-none", {
              "group-hover:text-np-green text-transparent": !active,
              "bg-np-green text-white": active,
            })}
          />
        )}

        {variant === "add" && (
          <NpIcon
            name="add"
            className={clsx("transition-[color,rotate] hover:transition-transform", {
              "rotate-[135deg] text-white": active,
              "text-np-green": !active,
            })}
          />
        )}
      </div>
    </Element>
  )
}
